import { createSelector } from 'redux-orm';

import orm from '../orm';

export const selectCardPointAdvancedDataForCardAndPointSystem = createSelector(
  orm,
  (_, cardId) => cardId,
  (_, __, pointSystemId) => pointSystemId,
  ({ CardPointAdvancedData }, cardId, pointSystemId) => {
    if (!cardId || !pointSystemId) {
      return [];
    }

    return CardPointAdvancedData.all()
      .filter({ cardId, pointSistemId: pointSystemId })
      .orderBy('id')
      .toRefArray();
  },
);

export default {
  selectCardPointAdvancedDataForCardAndPointSystem,
};

